import { render, staticRenderFns } from "./LegalDocumentsAndStandards.vue?vue&type=template&id=376cdb76&lang=pug"
import script from "./LegalDocumentsAndStandards.vue?vue&type=script&lang=js"
export * from "./LegalDocumentsAndStandards.vue?vue&type=script&lang=js"
import style0 from "./LegalDocumentsAndStandards.vue?vue&type=style&index=0&id=376cdb76&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports